module.exports = __webpack_public_path__ + "static/img/people-bg.2dc803f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mycenter/people-bg.png
// module id = i5s2
// module chunks = 0